import React from 'react';
import { IconProps } from './types';

export const BuyCryptoIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 25'
      fill='none'
    >
      <path
        d='M20.5714 7.92857C20.5714 7.14286 19.8701 6.5 19.013 6.5H4.98702C4.12987 6.5 3.42857 7.14286 3.42857 7.92857V10.7857H20.5714V7.92857Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.42857 10.7858V16.9572C3.42857 17.8058 4.12987 18.5001 4.98702 18.5001H19.013C19.8701 18.5001 20.5714 17.8058 20.5714 16.9572V10.7858H3.42857Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.42859 10.7858H20.5714'
        stroke='#DFF60D'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
